import { useNavigate } from '@tanstack/react-router';

import { useTokenContext } from '../../context/TokenProvider/TokenProvider';
import type { AppNavigate } from '../../lib/tanstackRouter/types';
import type { SearchLoginType } from '../../pages/LoginPage/route';
import { loginRoute } from '../../pages/LoginPage/route';

export const useLogout = () => {
	const { removeTokens: removePidTokens } = useTokenContext();
	const navigate: AppNavigate = useNavigate();

	const logout = (hasInvalidTokenRoles: boolean) => {
		const search: SearchLoginType = hasInvalidTokenRoles
			? { hasInvalidRoles: hasInvalidTokenRoles }
			: {};
		removePidTokens();
		navigate({
			to: loginRoute.fullPath,
			reloadDocument: true,
			search,
		});
	};

	return logout;
};
